import React from 'react'

export default function LinhaLegendaConsumo({ bgColor, titulo, tooltip }) {
  return (
    <div className="linha-legenda-consumo">
      <div className="coluna-legenda-consumo-1">
        <div
          className="esfera-legenda-dashboard"
          style={{ backgroundColor: bgColor }}
        />
      </div>
      <div className="coluna-legenda-consumo-2">
        <span className="fonte-cor-1 texto-legenda-consumo">{titulo}</span>
      </div>
      <div className="coluna-legenda-consumo-3">
        <span className="fonte-cor-1 texto-legenda-consumo-numero-unico-2">
          {tooltip}
        </span>
      </div>
    </div>
  )
}
